import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { RiAttachment2 } from "react-icons/ri";
import { MdEmojiEmotions } from "react-icons/md";
import { IoIosMore } from "react-icons/io";

const ChatArea = () => {
  return (
    <div className="w-2/4 p-2 h-[500px]">
      <h2 className="text-xl font-bold">Karan Singh Shekhawat</h2>
      <div className="text-sm text-gray-500 mb-4">video editor</div>
      <div className="space-y-4 overflow-y-auto h-[200px]">
        <div className="">
          <div className="text-sm flex w-full items-center gap-4 pb-3">
            <hr className="w-full border-b" />
            <p className="text-gray-500 min-w-[44px]">FEB 25</p>
            <hr className="w-full border-b" />
          </div>
          <div className="max-w-xs">
            <div className="w-full">
              <div className="w-full">
                <img
                  src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="w-12 h-12 rounded-full"
                />
              </div>
              <div className="w-full ">
                <div className="w-full flex items-center gap-2">
                  <p className="font-bold text-sm">Karan Singh Shekhawat</p> •{" "}
                  <p className="text-gray-500 text-sm">2:50 PM</p>
                </div>
                <div>
                  <p>want join logicpiece as a video editor</p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          <div className="bg-blue-500 text-white p-2 rounded-lg max-w-xs">
            Replying as LogicSpice Consultancy Private Ltd...
          </div>
        </div>
      </div>
      <div className="w-full mt-4 border-t border-b pt-2 pb-2">
        {/* <button className="mr-2">GIF</button> */}
        <input
          type="text"
          placeholder="Type a message..."
          className="p-2 border rounded h-[100px] w-full"
        />
        <p className="text-sm text-gray-500 flex items-center mt-2">
          <FaInfoCircle className="mr-1" /> Members won't see which admin
          responded
        </p>
        {/* <button className="ml-2 bg-blue-500 text-white p-2 rounded">Send</button> */}
      </div>
      <div className="flex items-center justify-between w-full mt-4 border-b pb-2">
        <div className="flex items-center gap-1 text-gray-500">
          <RiAttachment2 className="text-2xl pointer" />

          <button className="mr-2 ">GIF</button>
          <MdEmojiEmotions className="text-2xl" />
        </div>
        <div className="flex items-center gap-1">
          <button className="ml-2 px-4 py-2 text-sm bg-blue-500 text-white p-2 rounded-full">
            Send
          </button>
          <IoIosMore className="text-2xl" />
        </div>
      </div>
    </div>
  );
};

export default ChatArea;
